import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { isAuthenticated } from "./isAuthenticated";
import { useLogout } from "./Logout";
import { useUser } from "../userContext/UserContext";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { userData, setUserData } = useUser();
  const logout = useLogout();
  const [checkedAuth, setCheckedAuth] = useState(false);
  const storedData = localStorage.getItem("harenaCowonder");
  const hasStoredAuth = Boolean(storedData && isAuthenticated(storedData));

  useEffect(() => {
    if (userData == null) {
      const storedData = localStorage.getItem("harenaCowonder");

      if (storedData && isAuthenticated(storedData)) {
        setUserData(JSON.parse(storedData));
      } else {
        logout();
      }
    }

    setCheckedAuth(true);
  }, [userData, setUserData, logout]);

  if (!checkedAuth) {
    return null;
  }

  if (!userData && hasStoredAuth) {
    return null;
  }

  if (!userData || !isAuthenticated(JSON.stringify(userData))) {
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
